import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import axios from "axios";
import LeagueDialog from "src/components/leagues-admin/LeagueDialog";
import DeleteDialog from "../components/leagues-admin/DeleteDialog";
import RulesDialog from "../components/leagues-admin/RulesDialog";
// ----------------------------------------------------------------------
export default function CustomLeaguesPage() {
  const [rows, setRows] = useState(null);
  const [openLeagueDialog, setOpenLeagueDialog] = useState(false);
  const [showDeleteLeagueDialog, setShowDeleteLeagueDialog] = useState(false);

  const [editLeague, setEditLeague] = useState(null);
  const [deleteLeague] = useState(null);
  const [isShowRuleModal, setIsShowRuleModal] = useState(null);
  const [selectedLeague, setSelctedLeague] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leagues?limit=100&offset=0`
      )
      .then(function (response) {
        setRows(response.data.leagues.filter((item) => item !== null));
      });
  }, []);

  const successLeagueHandler = (league) => {
    if (league?.league_id) {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/league/${league.league_id}`,
          league
        )
        .then(function (response) {
          window.location.reload(false);
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/admin/league`, league)
        .then(function (response) {
          window.location.reload(false);
        });
    }
    setOpenLeagueDialog(false);
  };

  const deleteQuestionHandler = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/admin/league/${id}`)
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const closeLeagueDialog = () => {
    setEditLeague(null);
    setOpenLeagueDialog(false);
  };
  const openAddLeagueDialog = () => {
    setEditLeague(null);
    setOpenLeagueDialog(true);
  };
  const openEditLeagueDialog = (index) => {
    const league = rows[index];
    setEditLeague(league);
    setOpenLeagueDialog(true);
  };

  return (
    <>
      <Helmet>
        <title>Featured Leagues</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Featured Leagues
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => openAddLeagueDialog()}
          >
            New League
          </Button>
        </Stack>

        <Card>
          {rows === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Order</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Size</TableCell>
                      <TableCell>Sponsor slug</TableCell>
                      <TableCell>Vanity slug</TableCell>
                      <TableCell>Icon</TableCell>
                      <TableCell>Rules</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row?.league_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.order}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.type}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.size}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.sponsor_slug}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.vanity_slug}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <img alt="" style={{ width: 100 }} src={row?.icon} />
                        </TableCell>

                        <TableCell>
                          <Button
                            variant="contained"
                            onClick={() => {
                              setIsShowRuleModal(true);
                              setSelctedLeague(row);
                            }}
                          >
                            View Rules
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Iconify
                            icon={"eva:edit-outline"}
                            sx={{ cursor: "pointer" }}
                            onClick={() => openEditLeagueDialog(index)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <LeagueDialog
        league={editLeague}
        open={openLeagueDialog}
        onSuccessHandler={successLeagueHandler}
        onClose={closeLeagueDialog}
      />
      <DeleteDialog
        openConfirm={showDeleteLeagueDialog}
        setOpenConfirm={setShowDeleteLeagueDialog}
        questionIndex={deleteLeague}
        deleteGameHandler={deleteQuestionHandler}
        type={"league"}
      />
      <RulesDialog
        isShowRuleModal={isShowRuleModal}
        setIsShowRuleModal={setIsShowRuleModal}
        selectedLeague={selectedLeague}
        onSuccessHandler={successLeagueHandler}
      />
    </>
  );
}
